// Unified customer Content Tracker (SM-9880). Customer copy: plain language,
// sentence case, and no "review" / "feedback" wording.
export default {
    title: 'Content Tracker',
    description: 'Follow everything you\'ve sent to the editing team, from request to finished file.',
    quickStart: {
        howItWorks: 'How it works',
        eyebrow: 'A QUICK START',
        titleFirst: 'Track all your content.',
        titleSecond: 'In one place.',
        description: 'Every edit, every piece of media we create for you, and where each one stands right now.',
        dismiss: 'Dismiss Content Tracker introduction',
        stepsLabel: 'How the Content Tracker works',
        steps: {
            queued: {
                title: 'Requested',
                description: 'We have your request. An editor picks it up next.',
                example: 'Example: a new edit you asked for in Media Studio, or an intro and outro for your channel.',
            },
            inProgress: {
                title: 'In progress',
                description: 'An editor is working on it, then we check it before it reaches you.',
                example: 'Example: cutting your recording down, adding captions and your branding.',
            },
            needsYou: {
                title: 'Needs you',
                description: 'We need something from you before we can keep going. Reply and the work picks up again.',
                example: 'Example: a logo file, which take to use, or how to spell a guest\'s name.',
            },
            readyForYou: {
                title: 'Ready for you',
                description: 'Your finished edit is waiting. Open it to approve it or ask for changes.',
                example: 'Example: a new version of your video, ready to watch.',
            },
            completed: {
                title: 'Completed',
                description: 'Approved and finished. Download it anytime.',
                example: 'Example: a video you approved, or one that completed on its own after a few working days.',
            },
        },
        footnote: 'Videos and quick projects like intros, outros and graphics all show up here, in the same columns.',
    },
    stages: {
        needs_you: 'Needs you',
        queued: 'Requested',
        in_progress: 'In progress',
        ready_for_you: 'Ready for you',
        done: 'Completed',
    },
    empty: {
        needs_you: 'Nothing needs you right now.',
        queued: 'No new requests.',
        in_progress: 'Nothing in progress.',
        ready_for_you: 'Nothing ready yet.',
        done: 'Nothing completed yet.',
        noMatches: 'No matches. Try a different search or filter.',
        list: 'Nothing here yet. Request an edit in Media Studio to get started.',
    },
    sort: {
        label: 'Sort',
        newest: 'Newest first',
        oldest: 'Oldest first',
        longest: 'Longest in stage',
        shortest: 'Most recently moved',
        title_asc: 'Title A to Z',
        title_desc: 'Title Z to A',
        stage_asc: 'Stage',
        stage_desc: 'Stage, reversed',
    },
    filters: {
        search: 'Search',
        searchLabel: 'Search {filter} options',
        noOptions: 'No matching options.',
        allRequesters: 'All requesters',
        allEditors: 'All editors',
        noRequester: 'No requester',
        mine: 'Just my media',
        mineHint: 'Only what you created, asked to have edited, or collaborate on',
        label: 'Show',
        all: 'All',
        video: 'Videos',
        task: 'Tasks',
    },
    view: {
        label: 'View',
        board: 'Board',
        list: 'List',
    },
    search: {
        placeholder: 'Search by title, requester or CID',
        label: 'Search the Content Tracker',
        clear: 'Clear search',
    },
    stageFilter: {
        heading: 'Filter by',
        label: 'Stage: {stage}',
        all: 'All stages',
        showing: 'Showing {stage}',
        clear: 'Show all stages',
    },
    list: {
        project: 'Project',
        requester: 'Requester',
        assignedEditor: 'Assigned editor',
        unassigned: 'Unassigned',
        type: 'Type',
        stage: 'Stage',
        submitted: 'Submitted',
        timeInStage: 'Time in stage',
        actions: 'Actions',
    },
    card: {
        untitled: 'Untitled',
        submitted: 'Submitted {when}',
        delivered: 'Delivered {when}',
        completed: 'Completed {when}',
        completesOn: 'Completes {when} unless you ask for changes',
        autoCompletes: 'Auto-completes {when}',
        noPreview: 'No preview',
    },
    actions: {
        open: 'Open',
        copyLink: 'Copy link',
        linkCopied: 'Link copied',
        linkCopyFailed: 'Could not copy the link. Try again.',
        reply: 'Reply',
        showMore: 'Show more',
        loading: 'Loading',
    },
    hint: {
        open: 'Click a card to open it in Media Studio',
        rightClick: 'Right-click for more options',
        scroll: 'Scroll a column to see more',
    },
    menu: {
        openInMediaStudio: 'Open in Media Studio',
        openInNewTab: 'Open in new tab',
    },
    reply: {
        heading: 'We need a little more information',
        placeholder: 'Type your answer…',
        label: 'Your answer',
        send: 'Send answer',
        cancel: 'Cancel',
    },
    loadError: 'We couldn\'t load your Content Tracker. Try again.',
    retry: 'Try again',
}
